import { z } from 'zod'

// Универсальная схема для редактора: ?edit=N (открывает редактирование) и ?new=1
// (открывает форму создания). Если оба заданы — приоритет у `new` (см. компонент
// страницы). .coerce.number() — "?edit=42" → 42; .catch(undefined) — мусорный ввод
// игнорируется. .literal(1) для new — единственное допустимое значение, чтобы URL
// не плодил вариантов вроде ?new=true / ?new=yes.
export const editorSearchSchema = z.object({
  edit: z.coerce.number().int().positive().optional().catch(undefined),
  new:  z.coerce.number().int().pipe(z.literal(1)).optional().catch(undefined),
})
export type EditorSearch = z.infer<typeof editorSearchSchema>

// /tools — таб (catalog | drillstrings) + редактор. Таб дефолтит к 'catalog',
// при отсутствии параметра в URL читается как undefined → компонент трактует как
// 'catalog'. Не-валидное значение игнорируется (.catch).
//
// edit полиморфный: для каталога это `tool.id: Uuid` (string), для компоновок —
// `drillstring.id: i32` (number). Одно поле URL разруливается по `tab()` в
// route-компоненте. Порядок union важен: число matches first для drillstrings,
// иначе оставляем строку как есть (uuid).
export const toolsSearchSchema = z.object({
  tab:  z.enum(['catalog', 'drillstrings']).optional().catch(undefined),
  edit: z.union([z.coerce.number().int().positive(), z.string().min(1)]).optional().catch(undefined),
  new:  z.coerce.number().int().pipe(z.literal(1)).optional().catch(undefined),
})
export type ToolsSearch = z.infer<typeof toolsSearchSchema>
